import React, { useContext } from 'react';
import { GamesContext, IGamesContext } from 'modules/Entertainment/Games/Games/gamesState/gamesContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, games } = useContext<IGamesContext>(GamesContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={games.gamesCount ? 800 : undefined}
		/>
	);
};

export default Search;
